import React from "react";
import { FaAirbnb, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { GrDownload } from "react-icons/gr";

import axios from "axios";

const NewFooter = () => {
  return (
    <div className="relative w-full py-0 md:py-10 z-10 mt-0 bg-[#E8E4DE]">
      {/* ---------- DESKTOP ---------- */}
      <div className="hidden lg:block">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <footer
            className="relative w-full bg-[#E8E4DE] text-[#948A78] flex flex-col 
              justify-start items-center px-6 md:px-10 pt-4 pb-8 overflow-hidden"
          >
            <div className="flex flex-col md:flex-row justify-between items-start w-full max-w-6xl gap-12 mt-0">
              <div className="flex flex-col space-y-4 w-full md:w-1/3 xl:-ml-20 lg:-ml-10">
                <p className="text-[13px]  text-right xl:mr-44 lg:mr-28">
                  Slow down with Us.
                </p>

                <p className="text-[13px]  text-right mr-36 w-52">
                  Check availability or <br />
                  speak with us
                </p>

                <div className="space-y-12 text-[13px]  uppercase mt-8 mb-2 xl:tracking-[0.3em] lg:tracking-[0.1em]">
                  <div className="space-y-5 ml-52">
                    <a
                      href="mailto:sohamvillas@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                    >
                      sohamvillas@gmail.com
                    </a>

                    <p>
                      <a
                        href="tel:+917767047535"
                        className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                      >
                        +91 7767047535
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://www.instagram.com/sohamvillas/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        @sohamvillas
                      </a>
                    </p>
                  </div>

                  <div className="space-y-5 ml-52">
                    <a
                      href="mailto:houseoftao.goa@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                    >
                      houseoftao.goa@gmail.com
                    </a>

                    <p>
                      <a
                        href="tel:+918866262368"
                        className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                      >
                        +91 8866262368
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://www.instagram.com/houseoftao.goa"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        @houseoftao
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-1 w-full md:w-1/2 md:pl-20 xl:-mr-52">
                <div className="md:-ml-16 lg:-ml-72 lg:w-[280px] xl:-ml-72 xl:w-[240px] 2xl:-ml-56 2xl:w-[220px] 4k:-ml-96 4k:w-[400px]">
                  <p className="text-[13px]  mb-5 md:mb-1 mt-3 text-[#948A78] text-right leading-snug">
                    Be the First <br /> to Know
                  </p>
                </div>

                <p className="text-[13px]  text-left mr-36 mt-1">
                  Join the House of Tāo circle and receive early <br />
                  updates on bookings, curated experiences, <br />
                  and future retreats.
                </p>

                <form
                  onSubmit={async (e) => {
                    e.preventDefault();

                    const email = e.target.email.value;

                    if (!email) {
                      alert("Please enter an email");
                      return;
                    }

                    try {
                      const res = await axios.post(
                        "https://sohamvillas.com/web-backend/subscribeForTao",
                        {
                          email,
                        }
                      );

                      alert(res.data.message);
                      e.target.reset();
                    } catch (err) {
                      console.error(err);
                      alert("Something went wrong");
                    }
                  }}
                  className="flex border-b border-[#9b8b7a] items-center pb-1 max-w-md ml-auto xl:mr-72 2xl:mr-60 lg:mr-60 mt-6"
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="example@gmail.com"
                    className="flex-grow bg-transparent lg:text-[13px] outline-none placeholder-[#9b8b7a] placeholder-opacity-40 text-left"
                  />
                  <button
                    type="submit"
                    className="ml-28 text-[#9b8b7a] uppercase lg:text-[13px]"
                  >
                    Connect
                  </button>
                </form>
                <div className="mt-10 xl:ml-48 2xl:ml-28 lg:ml-48 4k:ml-52">
                  <a
                    href="../assets/House_of_Tao.pdf"
                    target="_blank"
                    className="flex items-center gap-2 text-[#948A78] cursor-pointer text-[14px]"
                  >
                    Download Brochure
                    <GrDownload />
                  </a>
                </div>
              </div>
            </div>

            <div className="absolute bottom-1 xl:right-32 lg:right-20 4k:left-[90vh] flex justify-center items-center text-[20px] gap-8">
              <a
                href="https://wa.me/918490984907"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp className="text-[#9b8b7a] hover:text-green-400 hover:scale-110 duration-300 cursor-pointer" />
              </a>
              <a
                href="https://www.instagram.com/houseoftao.goa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-[#9b8b7a] hover:text-pink-600 hover:scale-110 duration-300 cursor-pointer" />
              </a>
              <a
                href="https://airbnb.co.in/h/houseoftao"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaAirbnb className="text-[#9b8b7a] hover:text-red-500 hover:scale-110 duration-300 cursor-pointer" />
              </a>
            </div>
          </footer>
          <a
            href="https://inittechnology.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="absolute bottom-3 left-0 w-full text-center text-[#9b8b7a] text-[11px] hover:text-[#7a6c5f] duration-300"
          >
            copyright © Init Technology
          </a>
        </div>
      </div>

      {/* ---------- MOBILE ---------- */}
      <div className="block lg:hidden">
        <footer
          className="w-full bg-[#E8E4DE] text-[#948A78] flex flex-col justify-start items-center px-4 sm:px-6 py-10 text-center"
          style={{ fontFamily: "'Onest'" }}
        >
          <div className="flex flex-col items-center mb-10">
            <div className="mr-48 sm:mr-[37vh]">
              <p className="text-[13px] text-right  mb-3 text-[#948A78]">
                Be the First <br /> to Know
              </p>
            </div>

            <p className="text-[13px] ml-20 sm:ml-[37vh]  mb-5 text-left w-[240px]">
              Join the House of Tāo circle and receive early updates on
              bookings, curated experiences, and future retreats.
            </p>

            <form
              onSubmit={async (e) => {
                e.preventDefault();

                const email = e.target.email.value;

                if (!email) {
                  alert("Please enter an email");
                  return;
                }

                try {
                  const res = await axios.post(
                    "https://sohamvillas.com/web-backend/subscribeForTao",
                    {
                      email,
                    }
                  );

                  alert(res.data.message);
                  e.target.reset();
                } catch (err) {
                  console.error(err);
                  alert("Something went wrong");
                }
              }}
              className="flex border-b border-[#9b8b7a] items-right justify-right pb-1 ml-20 md:ml-60 w-[220px] sm:w-[260px] mx-auto"
            >
              <input
                type="email"
                name="email"
                placeholder="name@gmail.com"
                className="flex-grow bg-transparent text-[13px] outline-none placeholder-[#9b8b7a] placeholder-opacity-40 text-left"
              />
              <button
                type="submit"
                className=" text-[#9b8b7a] uppercase text-[13px] "
              >
                Connect
              </button>
            </form>
            <div className="mt-10 sm:ml-[44vw] ml-36">
              <a
                href="../assets/House_of_Tao.pdf"
                download
                className="flex items-center gap-2 text-[#948A78] cursor-pointer text-[14px]"
              >
                Download Brochure
                <GrDownload />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center text-center mt-6">
            <div className="mr-48 md:mr-64">
              <p className="text-[14px] sm:text-[13px] md:text-[14px]  mb-6">
                Slow down <br /> with Us
              </p>
            </div>

            <div className="space-y-8 text-[13px] sm:tracking-[0.2em] tracking-[0.1em] uppercase text-left ml-16 md:ml-10">
              <div className="space-y-3">
                <a
                  href="mailto:houseoftao.goa@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                >
                  houseoftao.goa@gmail.com
                </a>

                <p>
                  <a
                    href="tel:+918866262368"
                    className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                  >
                    +91 8866262368
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.instagram.com/houseoftao.goa"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @houseoftao
                  </a>
                </p>
              </div>

              <div className="space-y-3">
                <a
                  href="mailto:sohamvillas@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                >
                  sohamvillas@gmail.com
                </a>
                <p>
                  <a
                    href="tel:+917767047535"
                    className="text-[#9b8b7a] hover:text-[#7a6c5f]"
                  >
                    +91 7767047535
                  </a>
                </p>

                <p>
                  <a
                    href="https://www.instagram.com/sohamvillas/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @sohamvillas
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center gap-8 mt-10">
            <a
              href="https://wa.me/918490984907"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-green-400 hover:scale-110 duration-300 cursor-pointer" />
            </a>
            <a
              href="https://www.instagram.com/houseoftao.goa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-pink-600 hover:scale-110 duration-300 cursor-pointer" />
            </a>
            <a
              href="https://airbnb.co.in/h/houseoftao"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaAirbnb className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-red-500 hover:scale-110 duration-300 cursor-pointer" />
            </a>
          </div>
        </footer>
        <a
          href="https://inittechnology.co/"
          target="_blank"
          rel="noopener noreferrer"
          className="absolute bottom-1 sm:bottom-5 left-0 w-full text-center text-[#9b8b7a] text-[11px] hover:text-[#7a6c5f] duration-300"
        >
          copyright © Init Technology
        </a>
      </div>
    </div>
  );
};

export default NewFooter;

// import React from "react";
// import { FaAirbnb, FaWhatsapp, FaInstagram } from "react-icons/fa";

// const NewFooter = () => {
//   return (
//     <div className="relative w-full py-0 md:py-10 z-10 mt-0 bg-[#E8E4DE]">
//       {/* ---------- DESKTOP ---------- */}
//       <div className="hidden lg:block">
//         <div className="flex flex-col lg:flex-row justify-between gap-12">
//           <footer
//             className="relative w-full bg-[#E8E4DE] text-[#948A78] flex flex-col
//               justify-start items-center px-6 md:px-10 pt-4 pb-10 overflow-hidden"
//             style={{ fontFamily: "'Onest'" }}
//           >
//             <div className="flex flex-col md:flex-row justify-between items-start w-full max-w-6xl gap-12 mt-0">
//               <div className="flex flex-col space-y-4 w-full md:w-1/3 xl:-ml-20 lg:-ml-10">
//                 <p className="text-[13px]  text-right mr-44">
//                   Slow down with Us.
//                 </p>

//                 <p className="text-[13px]  text-right mr-36 w-52">
//                   Check availability or <br />
//                   speak with us
//                 </p>

//                 <div className="space-y-12 text-[13px]  uppercase mt-8 mb-2 xl:tracking-[0.3em] lg:tracking-[0.1em]">
//                   <div className="space-y-5 ml-52">
//                     <a
//                       href="mailto:sohamvillas@gmail.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                     >
//                       sohamvillas@gmail.com
//                     </a>

//                     <p>
//                       <a
//                         href="tel:+917767047535"
//                         className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                       >
//                         +91 7767047535
//                       </a>
//                     </p>

//                     <p>
//                       <a
//                         href="https://www.instagram.com/sohamvillas/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         @sohamvillas
//                       </a>
//                     </p>
//                   </div>

//                   <div className="space-y-5 ml-52">
//                     <a
//                       href="mailto:houseoftao.goa@gmail.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                     >
//                       houseoftao.goa@gmail.com
//                     </a>

//                     <p>
//                       <a
//                         href="tel:+918866262368"
//                         className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                       >
//                         +91 8866262368
//                       </a>
//                     </p>

//                     <p>
//                       <a
//                         href="https://www.instagram.com/houseoftao.goa"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         @houseoftao
//                       </a>
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-1 w-full md:w-1/2 md:pl-20 xl:-mr-52">
//                 <div className="md:-ml-16 lg:-ml-72 lg:w-[280px] xl:-ml-72 xl:w-[240px] 2xl:-ml-56 2xl:w-[220px] 4k:-ml-96 4k:w-[400px]">
//                   <p className="text-[13px]  mb-5 md:mb-1 mt-3 text-[#948A78] text-right leading-snug">
//                     Be the First <br /> to Know
//                   </p>
//                 </div>

//                 <p className="text-[13px]  text-left mr-36 mt-1">
//                   Join the House of Tāo circle and receive early <br />
//                   updates on bookings, curated experiences, <br />
//                   and future retreats.
//                 </p>

//                 <form className="flex border-b border-[#9b8b7a] items-center pb-1 max-w-md ml-auto mr-72 mt-6">
//                   <input
//                     type="email"
//                     placeholder="example@gmail.com"
//                     className="flex-grow bg-transparent lg:text-[13px] outline-none placeholder-[#9b8b7a] placeholder-opacity-40 text-left"
//                   />
//                   <button
//                     type="submit"
//                     className="ml-28 text-[#9b8b7a] uppercase lg:text-[13px]"
//                   >
//                     Connect
//                   </button>
//                 </form>
//               </div>
//             </div>

//             <div className="absolute bottom-1 xl:right-32 lg:right-20 4k:left-[90vh] flex justify-center items-center text-[20px] gap-8">
//               <a
//                 href="https://wa.me/918490984907"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaWhatsapp className="text-[#9b8b7a] hover:text-green-400 hover:scale-110 duration-300 cursor-pointer" />
//               </a>
//               <a
//                 href="https://www.instagram.com/houseoftao.goa"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaInstagram className="text-[#9b8b7a] hover:text-pink-600 hover:scale-110 duration-300 cursor-pointer" />
//               </a>
//               <a
//                 href="https://airbnb.co.in/h/houseoftao"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaAirbnb className="text-[#9b8b7a] hover:text-red-500 hover:scale-110 duration-300 cursor-pointer" />
//               </a>
//             </div>
//           </footer>
//         </div>
//       </div>

//       {/* ---------- MOBILE ---------- */}
//       <div className="block lg:hidden">
//         <footer
//           className="w-full bg-[#E8E4DE] text-[#948A78] flex flex-col justify-start items-center px-4 sm:px-6 py-10 text-center"
//           style={{ fontFamily: "'Onest'" }}
//         >
//           <div className="flex flex-col items-center mb-10">
//             <div className="mr-48 sm:mr-[37vh]">
//               <p className="text-[13px] text-right  mb-3 text-[#948A78]">
//                 Be the First <br /> to Know
//               </p>
//             </div>

//             <p className="text-[13px] ml-20 sm:ml-[37vh]  mb-5 text-left w-[240px]">
//               Join the House of Tāo circle and receive early updates on
//               bookings, curated experiences, and future retreats.
//             </p>

//             <form className="flex border-b border-[#9b8b7a] items-right justify-right pb-1 ml-20 md:ml-60 w-[220px] sm:w-[260px] mx-auto">
//               <input
//                 type="email"
//                 placeholder="name@gmail.com"
//                 className="flex-grow bg-transparent text-[13px] outline-none placeholder-[#9b8b7a] placeholder-opacity-40 text-left"
//               />
//               <button
//                 type="submit"
//                 className=" text-[#9b8b7a] uppercase text-[13px] "
//               >
//                 Connect
//               </button>
//             </form>
//           </div>

//           <div className="flex flex-col items-center text-center mt-6">
//             <div className="mr-48 md:mr-64">
//               <p className="text-[14px] sm:text-[13px] md:text-[14px]  mb-6">
//                 Slow down <br /> with Us
//               </p>
//             </div>

//             <div className="space-y-8 text-[13px] sm:tracking-[0.2em] tracking-[0.1em] uppercase text-left ml-16 md:ml-10">
//               <div className="space-y-3">
//                 <a
//                   href="mailto:houseoftao.goa@gmail.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                 >
//                   houseoftao.goa@gmail.com
//                 </a>

//                 <p>
//                   <a
//                     href="tel:+918866262368"
//                     className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                   >
//                     +91 8866262368
//                   </a>
//                 </p>
//                 <p>
//                   <a
//                     href="https://www.instagram.com/houseoftao.goa"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     @houseoftao
//                   </a>
//                 </p>
//               </div>

//               <div className="space-y-3">
//                 <a
//                   href="mailto:sohamvillas@gmail.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                 >
//                   sohamvillas@gmail.com
//                 </a>
//                 <p>
//                   <a
//                     href="tel:+917767047535"
//                     className="text-[#9b8b7a] hover:text-[#7a6c5f]"
//                   >
//                     +91 7767047535
//                   </a>
//                 </p>

//                 <p>
//                   <a
//                     href="https://www.instagram.com/sohamvillas/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     @sohamvillas
//                   </a>
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-center items-center gap-8 mt-10">
//             <a
//               href="https://wa.me/918490984907"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaWhatsapp className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-green-400 hover:scale-110 duration-300 cursor-pointer" />
//             </a>
//             <a
//               href="https://www.instagram.com/houseoftao.goa"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaInstagram className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-pink-600 hover:scale-110 duration-300 cursor-pointer" />
//             </a>
//             <a
//               href="https://airbnb.co.in/h/houseoftao"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaAirbnb className="text-[#9b8b7a] text-[18px] sm:text-[20px] hover:text-red-500 hover:scale-110 duration-300 cursor-pointer" />
//             </a>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default NewFooter;
